/* RESPONSIBLE TEAM: team-proactive-support */
import { attr, belongsTo } from '@ember-data/model';
import BaseStat from './base-stat';

export default BaseStat.extend({
  userGoalAttributes: attr(),
  successfulCompany: belongsTo('company'),
});
